import { render, staticRenderFns } from "./student-tutorial.vue?vue&type=template&id=2c84082f&"
import script from "./student-tutorial.vue?vue&type=script&lang=js&"
export * from "./student-tutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports